/** 样式 */

<style lang="scss" src="./BimEngineeringChangeItem.vue.scss"></style>
<template>
  <div class="table bimEngineeringChangeItem">
    <h3 class="canmove">
      <span>{{ this.title }}变更项</span>
      <i class="el-icon-close" @click="hutDown()"></i>
    </h3>
    <el-form :model="form" class="settings" label-width="80px">
      <!-- <el-form-item label="序号：" class="description">
        <el-input v-model="form.sort" placeholder="请输入序号"></el-input>
      </el-form-item> -->
      <el-form-item label="变更项名：" class="description">
        <el-input
          type="textarea"
          placeholder="点此输入变更项名"
          v-model="form.name"
          clearable
          resize="none"
        >
        </el-input>
      </el-form-item>

      <el-form-item label="新模型：" class="description">
        <el-input
          v-model="form.NewModel"
          placeholder="请粘贴该新模型对应的地址链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="旧模型：" class="description">
        <el-input
          v-model="form.OldModel"
          placeholder="请粘贴该旧模型对应的地址链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="描述：" class="description">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="点此输入描述"
          v-model="form.desc"
          clearable
          resize="none"
        >
        </el-input>
      </el-form-item>

      <el-form-item class="btns">
        <el-button type="primary" @click="onSubmit" style="margin-left: 39px"
          >确认提交
        </el-button>
      </el-form-item>
      <!-- <el-button v-if="1" @click="deleteTransform(index)">删除变更项</el-button> -->
      <!-- <el-button v-else @click="bimEngineeringChangeItem_clean">移除变更项</el-button> -->
    </el-form>
  </div>
</template>
<script>
import {
  getBimEngineeringChange,
  addBimEngineeringChangeItem,
  editBimEngineeringChangeItem,
} from "../../../../api/api";
export default {
  name: "map-from",
  components: {},
  props: ["changeItemShow", "hutDown", "title"],
  data() {
    return {
      treedata: [],
      form: {
        id: "", //变更项id
        parentId: "", //项目id
        name: "", //变更项名
        NewModel: "", //新模型地址
        OldModel: "", //旧模型地址
        pId: 0, //变更分类id
        desc: "",
        sort: "",
        position: "",
      },
      // title: "新增",
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {
    //一个对象，键是需要观察的表达式，值是对应回调函数。
    //值也可以是方法名，或者包含选项的对象。
    //Vue 实例将会在实例化时调用 watch()，遍历 watch 对象的每一个 property。
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    this.initTreeData();
  },

  methods: {
    // 树形数据请求
    // 初始化列表
    initTreeData() {
      this.hutDown();
      let tempdata = [];
      let modelData = {
        ProjectId: window.sessionStorage.getItem("nowProjectId"),
      };
      getBimEngineeringChange(modelData).then((res) => {
        tempdata = res.data.data;
        console.log(res.data.data);
        tempdata.forEach((item) => {
          console.log(item);
          if (item["children"] != null && item["children"].length > 0) {
            item["transformType"] = "directory";
          }
          item.children.forEach((i) => {
            console.log(i);
          });
          this.treedata = tempdata;
        });
      });
    },
    // 新增变更项数据请求
    onSubmit() {
      //this.changeItemShow = false;
      let mreData = {
        id: this.form.id,
        projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
        pId: this.form.pId,
        name: this.form.name,
        newModel: this.form.NewModel.url,
        oldModel: this.form.OldModel.url,
        description: this.form.desc,
        sort: this.form.sort,
        x: 0,
        y: 0,
        z: 0,
      };
      console.log("mreData", mreData);

      if (this.form.id != 0) {
        editBimEngineeringChangeItem(mreData).then((res) => {
          if (res.data.success && res.data.code === 204) {
            this.$notify({
              title: "已成功修改该变更项。",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.initTreeData();
            this.changeItemShow = false;
          } else {
            this.$alert("修改该变更项失败了，请再试一次吧~", "修改失败", {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            });
            this.initTreeData();
            this.changeItemShow = false;
          }
        });
      } else {
        addBimEngineeringChangeItem(mreData).then((res) => {
          if (res.data.success && res.data.code === 200) {
            this.$notify({
              title: "已成功新增变更项。",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            this.changeItemShow = false;
            this.initTreeData();
          } else {
            this.$alert("新增该变更项失败了，请再试一次吧~", "新增失败", {
              confirmButtonText: "确定",
              type: "error",
              callback: (action) => {},
            });
            this.initTreeData();
            this.changeItemShow = false;
          }
        });
      }
    },

    // 移除变更项
    bimEngineeringChangeItem_clean() {},
  },

  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    //该钩子在服务器端渲染期间不被调用，因为只有初次渲染会在服务端进行。
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    //然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  },
  activated() {
    //被 keep-alive 缓存的组件激活时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  deactivated() {
    //被 keep-alive 缓存的组件停用时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  beforeUnmount() {
    //实例销毁之前调用。在这一步，实例仍然完全可用。
    //该钩子在服务器端渲染期间不被调用。
  },
  unmounted() {
    //实例销毁后调用。该钩子被调用后，对应 Vue 实例的所有指令都被解绑，所有的事件监听器被移除，所有的子实例也都被销毁。
    //该钩子在服务器端渲染期间不被调用。
  },
  errorCaptured() {
    //当捕获一个来自子孙组件的错误时被调用。
    //此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    //此钩子可以返回 false 以阻止该错误继续向上传播。
  },
};
</script>
